var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBreadcrumb)?_c('a-breadcrumb',{staticClass:"mx-0",attrs:{"routes":_vm.routes},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var params = ref.params;
var routes = ref.routes;
return [(routes.indexOf(route) === routes.length - 1)?_c('span',{staticClass:"text-lg font-semibold"},[_vm._v(_vm._s(route.breadcrumbName))]):_c('router-link',{staticClass:"text-base underline",attrs:{"to":route.path}},[_vm._v(" "+_vm._s(route.breadcrumbName)+" ")])]}}],null,false,287162601)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }